
import { Link } from 'react-router-dom';
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const ServicesSection = () => {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section 
      ref={sectionRef}
      className="py-12 sm:py-24 px-4 sm:px-6 lg:px-12 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        <div 
          className={`flex flex-col lg:flex-row justify-between items-start mb-8 sm:mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 lg:mb-0">
            Compramos Tu Coche<br />en <strong>Gavá</strong>
          </h2>
          <p className="text-sm sm:text-lg text-gray-600 max-w-md leading-relaxed">
            Ofrecemos el <strong>mejor precio por tu vehículo siniestrado o averiado en Gavá</strong>. Valoración gratuita en menos de 2 horas.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-8">
          <div 
            className={`sm:col-span-1 bg-gradient-to-br from-gray-900 to-emerald-900 rounded-xl sm:rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all hover:scale-[1.02] cursor-pointer duration-700 delay-100 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}
          >
            <div className="h-40 sm:h-64 overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/e4e38ba6dcebecd60d8f0d5afada628b.jpg"
                alt="Compra de coches siniestrados en Gavá"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-5 sm:p-8">
              <h3 className="text-lg sm:text-2xl font-bold text-white mb-2 sm:mb-3">
                <strong>Coches Siniestrados</strong>
              </h3>
              <p className="text-white/80 leading-relaxed mb-3 sm:mb-4 text-xs sm:text-base">
                Compramos vehículos con daños por accidente en Gavá y comarca. La mejor valoración del mercado.
              </p>
              <Link
                to="/servicios"
                className="inline-flex items-center text-emerald-400 hover:text-emerald-300 font-medium transition-colors whitespace-nowrap text-sm sm:text-base"
              >
                Más información
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>

          <div 
            className={`bg-gradient-to-br from-gray-900 to-emerald-900 rounded-xl sm:rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all hover:scale-[1.02] cursor-pointer duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}
          >
            <div className="h-40 sm:h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=broken%20down%20car%20mechanical%20failure%20old%20vehicle%20with%20engine%20problems%20worn%20out%20automobile%20on%20simple%20clean%20white%20background%20professional%20studio%20lighting%20high%20quality%20product%20photography%20realistic%20detailed%20three%20quarter%20view%20compact%20car&width=600&height=400&seq=service-averiado-002&orientation=landscape"
                alt="Compra de coches averiados en Gavá"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-5 sm:p-8">
              <h3 className="text-lg sm:text-2xl font-bold text-white mb-2 sm:mb-3">
                <strong>Coches Averiados</strong>
              </h3>
              <p className="text-white/80 leading-relaxed mb-3 sm:mb-4 text-xs sm:text-base">
                ¿Tu coche no arranca o tiene averías graves? Lo compramos sin importar su estado mecánico.
              </p>
              <Link
                to="/servicios"
                className="inline-flex items-center text-emerald-400 hover:text-emerald-300 font-medium transition-colors whitespace-nowrap text-sm sm:text-base"
              >
                Ver detalles
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>

          <div 
            className={`sm:col-span-2 md:col-span-1 bg-gradient-to-br from-gray-900 to-emerald-900 rounded-xl sm:rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all hover:scale-[1.02] cursor-pointer duration-700 delay-300 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}
          >
            <div className="h-40 sm:h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=tow%20truck%20car%20recovery%20vehicle%20transporting%20automobile%20professional%20towing%20service%20on%20simple%20clean%20white%20background%20modern%20flatbed%20truck%20carrying%20car%20studio%20lighting%20high%20quality%20realistic%20side%20view%20commercial%20vehicle&width=600&height=400&seq=service-retirada-003&orientation=landscape"
                alt="Retirada gratuita de coches en Gavá con grúa"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-5 sm:p-8">
              <h3 className="text-lg sm:text-2xl font-bold text-white mb-2 sm:mb-3">
                <strong>Retirada Gratuita</strong>
              </h3>
              <p className="text-white/80 leading-relaxed mb-3 sm:mb-4 text-xs sm:text-base">
                Servicio de grúa 100% gratuito. Recogemos tu vehículo donde esté en toda la comarca.
              </p>
              <Link
                to="/servicios"
                className="inline-flex items-center text-emerald-400 hover:text-emerald-300 font-medium transition-colors whitespace-nowrap text-sm sm:text-base"
              >
                Solicitar recogida
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
